/* eslint-disable react/jsx-props-no-spreading */

"use client";

import AddPromoCode from "@/components/molecules/review-section/add-promo-code";
import { PromoVoucherCodeSchemaType } from "@/schema/renewal-page/payment-summary-page.schema";

type PromoCodeProps = {
  content: PromoVoucherCodeSchemaType;
};

export function PromoCode({ content }: PromoCodeProps) {
  return (
    <div className="mt-spacing-l md:mt-spacing-xl px-spacing-m py-spacing-m md:pb-spacing-xl md:pt-spacing-xxl md:px-spacing-xxxl lg:py-spacing-xxl lg:px-spacing-xxl bg-surface-neutral-option-1 rounded-radius-xxl">
      <AddPromoCode {...content} />
    </div>
  );
}
